module.exports = __webpack_public_path__ + "static/03-c2bbe36aa8ad980cf6b210dc98c30a96.jpg";